import React from 'react'
import './CourseSection.css'
import { FaPlay } from 'react-icons/fa'
import { BiTime } from 'react-icons/bi'
import { Row, Col } from 'react-bootstrap'
import { BsDownload, BsFillUnlockFill, BsCameraVideoFill, BsFillLockFill } from 'react-icons/bs'
import { useState } from 'react'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import ReactPlayer from 'react-player'

export default function CourseSection({ section, isBuyer }) {
    const [showVideo, setShowVideo] = useState(false)
    const handleShowVideo = () => {
        setShowVideo(!showVideo)
    }
    let totalMinutes = 0
    if (section.duration != null) {
        var timeArray = section.duration?.split(':');

        var hours = parseInt(timeArray[0]);
        var minutes = parseInt(timeArray[1]);

        totalMinutes = hours * 60 + minutes;
        totalMinutes += `:${parseInt(timeArray[2])}`
    }
    return (
        <div className='course-section'>
            <Row className='course-section-row'>
                <Col md={12} lg={6}>
                    <div className='course-section-right'>
                        <div className='course-section-right-icon'>
                            <BsCameraVideoFill />
                        </div>
                        <h3>{section.title}</h3>
                        <span>
                            <BiTime />
                            {totalMinutes} دقیقه
                        </span>
                    </div>
                </Col>
                <Col md={12} lg={6}>
                    <div className='course-section-left'>
                        {
                            !isBuyer ? section.isPrivate ? (
                                <>
                                    <div className='course-section-access'>
                                        <BsFillUnlockFill />
                                        دسترسی رایگان
                                    </div>
                                    <div className='course-section-download'>
                                        <FaPlay onClick={handleShowVideo} />
                                    </div>

                                </>

                            ) : (
                                <div className='course-section-access'>

                                    <BsFillLockFill />
                                </div>
                            ) : (
                                <>
                                    <div className='course-section-access'>
                                        <BsFillUnlockFill />
                                        دسترسی رایگان
                                    </div>
                                    <div className='course-section-download'>
                                        <FaPlay onClick={handleShowVideo} />
                                    </div>

                                </>

                            )
                        }

                    </div>
                </Col>
            </Row>
            {
                showVideo ? !isBuyer ? section.isPrivate ? (
                    <div className='course-section-video'>
                        <ReactPlayer
                            url={axiosConfig.defaults.baseURL + "Images/CourseVideo/" + section.id + "/" + section.videoPath}
                            config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                            onContextMenu={e => e.preventDefault()}
                            controls
                        />
                    </div>

                ) : (null) : (
                    <div className='course-section-video'>
                        <ReactPlayer
                            url={axiosConfig.defaults.baseURL + "Images/CourseVideo/" + section.id + "/" + section.videoPath}
                            config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                            onContextMenu={e => e.preventDefault()}
                            controls
                        />
                    </div>

                ) : (null)
            }

        </div>
    )
}
